
  import { css } from 'lit';
  export const styles = css`:host{--ig-theme: fluent;--ig-theme-variant: light}`;
  